import { render, staticRenderFns } from "./serviceinfoRecord.vue?vue&type=template&id=06b20eda&"
import script from "./serviceinfoRecord.vue?vue&type=script&lang=js&"
export * from "./serviceinfoRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports